/**
 * String lengths match EF Core configuration in
 * API/DataLayer/EntityModels/PricebrosContext.cs (Warranty, WarrantyLabor,
 * WarrantyPartsReplaced, WarrantyPhoto).
 */
export const WARRANTY_DESCRIPTION_MAX_LENGTH = 1000;
export const WARRANTY_DESCRIPTION_MIN_LENGTH = 50;

/** Main warranty claim form: maps HTML input name -> max length */
export const warrantyClaimStringFieldMaxLength: Record<string, number> = {
  filledOutByName: 100,
  filledOutByEmail: 150,
  customerName: 100,
  customerAddress: 100,
  customerCity: 100,
  customerState: 100,
  customerZip: 100,
  attachmentsAdded: 100,
  serialNumber: 100,
  model: 100,
  tractorMake: 100,
  tractorModel: 100,
  sellingDealerName: 100,
  sellingDealerAddress: 100,
  sellingCity: 100,
  sellingState: 100,
  sellingZip: 100,
};

export const WARRANTY_PART_PART_NUMBER_MAX_LENGTH = 50;
export const WARRANTY_PART_DESCRIPTION_MAX_LENGTH = 500;
export const WARRANTY_PART_INITIALS_MAX_LENGTH = 50;

export const WARRANTY_LABOR_DESCRIPTION_MAX_LENGTH = 500;

export const WARRANTY_PHOTO_NOTES_MAX_LENGTH = 500;

export function truncateToMaxLength(max: number, value: string): string {
  if (value.length <= max) return value;
  return value.slice(0, max);
}
